import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-use-cases',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './use-cases.html',
  styleUrl: './use-cases.scss',
})
export class UseCases {
  ts = inject(TranslationService);
  t = this.ts.t;

  cases = computed(() => [
    {
      title: this.t().uc_deck_title,
      desc: this.t().uc_deck_desc,
      color: '#f59e0b',
      feats: [this.t().uc_deck_feat1, this.t().uc_deck_feat2, this.t().uc_deck_feat3, this.t().uc_deck_feat4, this.t().uc_deck_feat5],
    },
    {
      title: this.t().uc_helideck_title,
      desc: this.t().uc_helideck_desc,
      color: '#22c55e',
      feats: [this.t().uc_helideck_feat1, this.t().uc_helideck_feat2, this.t().uc_helideck_feat3, this.t().uc_helideck_feat4],
    },
    {
      title: this.t().uc_engine_title,
      desc: this.t().uc_engine_desc,
      color: '#ef4444',
      feats: [this.t().uc_engine_feat1, this.t().uc_engine_feat2, this.t().uc_engine_feat3, this.t().uc_engine_feat4],
    },
    {
      title: this.t().uc_bridge_title,
      desc: this.t().uc_bridge_desc,
      color: '#3b82f6',
      feats: [this.t().uc_bridge_feat1, this.t().uc_bridge_feat2, this.t().uc_bridge_feat3, this.t().uc_bridge_feat4],
    },
  ]);
}